import { HTMLSpocUIProps, Orientation, PropGetter } from "@/types";
import { ReactNode, Ref, useCallback, useMemo } from "react";
import {
  timelineItemClasses,
  TimelineVariantProps,
} from "./TimelineItem.style";

interface Props extends HTMLSpocUIProps<"ol"> {
  /**
   * Ref to the DOM node.
   */
  ref?: Ref<HTMLElement> | undefined;
  /**
   * The orientation of the separator.
   * @default 'horizontal'
   */
  orientation?: Orientation;
}

export type TimelineItemProps = Props &
  Omit<TimelineVariantProps, "orientation"> & {
    title?: string;
    description?: string;
    time?: string;
    icon?: ReactNode;
  };

export const useTimelineItem = (props: TimelineItemProps) => {
  const { className, orientation, isNumeric, ...otherProps } = props;

  const styles = useMemo(
    () =>
      timelineItemClasses({
        orientation: orientation,
        isNumeric: isNumeric,
        className,
      }),
    [orientation, className]
  );

  const getTimelineItemProps: PropGetter = useCallback(
    (props = {}) => ({
      className: styles,
      role: "timeline",
      "data-orientation": orientation,
      isNumeric,
      ...otherProps,
      ...props,
    }),
    [styles, orientation, isNumeric, otherProps]
  );
  return { getTimelineItemProps };
};

export type TimelineItemReturn = ReturnType<typeof useTimelineItem>;
